export enum OrderChannel {
  TABLE = "TABLE",
  COUNTER = "COUNTER",
  TAKEAWAY = "TAKEAWAY",
  DELIVERY = "DELIVERY",
  ONLINE = "ONLINE", // Online order channel
}

export const OrderChannelLabels = {
  [OrderChannel.TABLE]: "Table Service",
  [OrderChannel.COUNTER]: "Counter",
  [OrderChannel.TAKEAWAY]: "Takeaway",
  [OrderChannel.DELIVERY]: "Delivery",
  [OrderChannel.ONLINE]: "Online",
};

